<template>
  <header class="dentist-container header" id="header">
    <div class="row no-gutters align-items-center">
      <div class="d-block d-md-none col-4">
        <MenuToggler view="header"/>
        <router-link to="/calendar">
          <img src="/images/general/logo_short.png" class="header__logo"/>
        </router-link>
      </div>
      <div class="text-right col-lg col-8">
        <div class="d-flex align-items-center justify-content-end">
          <HeaderUser class="header__item ml-md-4 ml-0"/>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import HeaderUser from "../parts/header/HeaderUser"
import MenuToggler from "@/components/parts/header/MenuToggler"
</script>
